import React from 'react';
import PropTypes from 'prop-types';

function EmployerReferralTerms() {
  return (
    <div>
      <h1 className="bold">
        Clora Employer Referral Program Terms &amp; Conditions
      </h1>

      <p>
        The Clora Employer Referral Program (“The Program”) allows registered Clora users
        (a “Clora User”) to earn a referral reward (“The Reward”) by referring friends and
        colleagues (a “Candidate”) to Clora. To participate, Clora Users must agree to these
        terms, which become part of the Clora Terms of Service.
      </p>

      <h4 className="bold">How To Earn Referral Reward</h4>

      <p>
        Clora Users can earn a Reward if:
        1) the Candidate is a new user of Clora,
        2) the Candidate clicks the Clora User’s referral link to create a valid Clora
        account that complies with our Terms of Service,
        3) the Candidate posts an approved Project, and
        4) a Consultant is successfully matched to that Project (a “Match”).
        Projects are approved at the sole discretion of Clora.
      </p>

      <p>
        The referring Clora User will be credited with the Reward described in the referral
        invitation or accompanying promotional materials. Only one (1) Reward will be paid per
        Candidate regardless of the number of Projects and Matches for which such Candidate
        receives referrals.
      </p>

      <p>
        A Candidate may only use one referral link. If a Candidate receives referral links
        from multiple Clora Users, only the corresponding Clora User of the referral link
        used by the Candidate is eligible for the Reward.
      </p>

      <p>
        Clora Users may not refer anyone who is an existing Clora user, including an existing
        user with an account under an alternate email address. All Candidates referred must be
        new Clora users. A new Clora user means someone who never before started a Clora
        account. Clora Users may not use spam or send unsolicited emails to persons they
        don’t personally know to collect referrals and may not collect referrals by posting
        on message boards or other online venues in violation of such venues’ terms of use.
      </p>

      <h4 className="bold">Termination and Changes</h4>

      <p>
        Clora may suspend or terminate The Program or a user’s ability to participate in
        The Program at any time for any reason.
      </p>

      <p>
        Clora reserves the right to cancel any rewards if it determines, in its sole
        discretion, that a Clora User has violated these terms, including through any
        fraudulent or misleading referral activity or if Clora terminates the Clora User’s
        account for any reason.
      </p>

      <p>
        The scope, variety, and type of services and products that you may obtain from the
        Reward can change at any time. Determination of Reward eligibility, as well as
        any exceptions, are at the sole discretion of Clora. Clora reserves the right to
        verify eligibility and adjust offers at any time prior to or following posting
        and/or award.
      </p>

      <p>
        Clora can update these terms at any time without prior notice. If Clora modifies
        these terms, we will post the modification on the Clora website,
        applications, or services, which are effective upon posting. Continued
        participation in the Program after any modification shall constitute
        consent to such modification.
      </p>
    </div>
  );
}

function ConsultantReferralTerms() {
  return (
    <div>
      <h1 className="bold">
        Clora Consultant Referral Program Terms &amp; Conditions
      </h1>

      <p>
        The Clora Consultant Referral Program (“The Program”) allows registered Clora users
        (a “Clora User”) to earn a referral reward (“The Reward”) by referring friends and
        colleagues (a “Candidate”) to Clora. To participate, Clora Users must agree to these
        terms, which become part of the Clora Terms of Service.
      </p>

      <h4 className="bold">How To Earn Referral Reward</h4>

      <p>
        Clora Users can earn a Reward if: 1) the Candidate is a new user of Clora, 2) the
        Candidate clicks the Clora User’s referral link to create a valid Clora account
        that complies with our Terms of Service, 3) the Candidate applies for an approved
        Project, and 4) the Candidate is successfully matched to that Project (a “Match”).
      </p>

      <p>
        The referring Clora User will be credited with the Reward described in the referral
        invitation or accompanying promotional materials. Only one (1) Reward will be paid
        per Candidate regardless of the number of Projects and Matches for which such
        Candidate receives referrals.
      </p>

      <p>
        A Candidate may only use one referral link. If a Candidate receives referral links
        from multiple Clora Users, only the corresponding Clora User of the referral link
        used by the Candidate is eligible for the Reward.
      </p>

      <p>
        Clora Users can refer anyone including existing Clora users, unless it is an alternate
        email of an existing Clora user. However, the Reward is only eligible for referring
        new Clora users. A new Clora user means someone who never before started a Clora
        account. Clora Users may not use spam or send unsolicited emails to persons they
        don’t personally know to collect referrals and may not collect referrals by
        posting on message boards or other online venues in violation of such venues’ terms of use.
      </p>

      <h4 className="bold">Termination and Changes</h4>

      <p>
        Clora may suspend or terminate The Program or a user’s ability to participate in
        The Program at any time for any reason.
      </p>

      <p>
        Clora reserves the right to cancel any rewards if it determines, in its sole discretion,
        that a Clora User has violated these terms, including through any fraudulent or misleading
        referral activity or if Clora terminates the Clora User’s account for any reason.
      </p>
    </div>
  );
}

function ReferralTerms({ isEmployer }) {
  return isEmployer ? <EmployerReferralTerms /> : <ConsultantReferralTerms />;
}

ReferralTerms.propTypes = {
  isEmployer: PropTypes.bool.isRequired,
};

export default ReferralTerms;
